// extracted by mini-css-extract-plugin
module.exports = {"confidencePercents":"confidencePercents__f55RS"};